// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reg-head {
  font-family: "Inter";
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
  padding-right: 2%;
  display: flex;
  align-items: center;
}
.reg-head__buttons {
  display: flex;
  margin-left: auto;
}
.reg-head__invite {
  margin-right: 10px;
}

.reg-table {
  margin-top: 30px;
}
.reg-table__table {
  width: 100%;
}

.reg-table-td {
  width: 50%;
  padding-right: 20px;
}

.reg-card {
  width: 100%;
  border-radius: 16px;
  background: white;
}
.reg-card__header {
  padding-top: 5%;
  padding-left: 5%;
  padding-right: 5%;
  padding-bottom: 2%;
}
.reg-card__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
}
.reg-card__subhead {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
  margin-top: 10px;
}

.reg-num {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #49ae9e;
}

.table-reg {
  width: 100%;
  border-collapse: collapse;
}
.table-reg__tr {
  height: 50px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 32px;
}
.table-reg__tr:hover {
  height: 50px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 32px;
  background: #fffcf2;
}
.table-reg__td {
  border-bottom: 1px solid #e9e9e9;
  border-top: 1px solid #868686;
}
.table-reg__td__table-name {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #505054;
  border-top: 1px solid #E9E9E9;
  border-bottom: 1px solid #E9E9E9;
}
.table-reg__td__table-content {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #505054;
  border-top: 1px solid #E9E9E9;
  border-bottom: 1px solid #E9E9E9;
}
.table-reg__td-center {
  text-align: center;
  border-bottom: 1px solid #e9e9e9;
  border-top: 1px solid #868686;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  padding-left: 10px;
}
.table-reg__th {
  background: #fafafa;
}
.table-reg__buttons {
  padding: 20px;
  display: flex;
}
.table-reg__buttons__cancel {
  padding-right: 10px;
}

.table-height {
  height: 50vh;
  padding: 10px;
}

.no-data {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #c1c1c1;
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.employee-registration-popup {
  margin: auto;
  padding: 12px;
  background-color: #ffffff !important;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
}
.employee-registration-popup__icon {
  cursor: pointer;
}
.employee-registration-popup__resend-invite {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  cursor: pointer;
  padding-top: 4px;
}
.employee-registration-popup__delete-invite {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  cursor: pointer;
  padding-top: 12px;
}
.employee-registration-popup__pop:hover {
  background-color: rebeccapurple;
  color: white;
}

.popup-content {
  border: none;
  background: none;
}

[role=tooltip].popup-content {
  box-shadow: none;
  border-radius: 5px;
}

.error {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #bbbbbb;
}`, "",{"version":3,"sources":["webpack://./src/screens/employee-registration/employee-registration.scss"],"names":[],"mappings":"AAGA;EACI,oBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,iBAAA;EACA,aAAA;EACA,mBAAA;AAHJ;AAKI;EACI,aAAA;EACA,iBAAA;AAHR;AAMI;EACI,kBAAA;AAJR;;AAQA;EACI,gBAAA;AALJ;AAOI;EACI,WAAA;AALR;;AASA;EACI,UAAA;EACA,mBAAA;AANJ;;AASA;EACI,WAAA;EACA,mBAAA;EACA,iBAAA;AANJ;AAQI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AANR;AASI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAPR;AAUI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,gBAAA;AATR;;AAaA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAVJ;;AAaA;EACI,WAAA;EACA,yBAAA;AAVJ;AAYI;EACI,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAVR;AAcI;EACI,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AAZR;AAgBI;EACI,gCAAA;EACA,6BAAA;AAdR;AAgBQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;EACA,gCAAA;AAdZ;AAiBQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;EACA,gCAAA;AAfZ;AAmBI;EACI,kBAAA;EACA,gCAAA;EACA,6BAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,kBAAA;AAlBR;AAkCI;EACI,mBAAA;AAhCR;AAmCI;EACI,aAAA;EACA,aAAA;AAjCR;AAmCQ;EACI,mBAAA;AAjCZ;;AAsCA;EACI,YAAA;EACA,aAAA;AAnCJ;;AAsCA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AApCJ;;AAuCA;EACI,YAAA;EAGA,aAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;AAtCJ;AAyCI;EACI,eAAA;AAvCR;AA0CI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAxCR;AA2CI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAzCR;AA4CI;EACI,+BAAA;EACA,YAAA;AA1CR;;AA8CA;EACI,YAAA;EACA,gBAAA;AA3CJ;;AA8CA;EACI,gBAAA;EACA,kBAAA;AA3CJ;;AA8CA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA3CJ","sourcesContent":[".employee-registration {\n}\n\n.reg-head {\n    font-family: 'Inter';\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 38px;\n    color: #333333;\n\n    padding-right: 2%;\n    display: flex;\n    align-items: center;\n\n    &__buttons {\n        display: flex;\n        margin-left: auto;\n    }\n\n    &__invite {\n        margin-right: 10px;\n    }\n}\n\n.reg-table {\n    margin-top: 30px;\n\n    &__table {\n        width: 100%;\n    }\n}\n\n.reg-table-td {\n    width: 50%;\n    padding-right: 20px;\n}\n\n.reg-card {\n    width: 100%;\n    border-radius: 16px;\n    background: white;\n\n    &__header {\n        padding-top: 5%;\n        padding-left: 5%;\n        padding-right: 5%;\n        padding-bottom: 2%;\n    }\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 24px;\n        color: #333333;\n    }\n\n    &__subhead {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        color: #666666;\n\n        margin-top: 10px;\n    }\n}\n\n.reg-num {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 24px;\n    color: #49ae9e;\n}\n\n.table-reg {\n    width: 100%;\n    border-collapse: collapse;\n\n    &__tr {\n        height: 50px;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        padding: 8px 32px;\n        // cursor: pointer;\n    }\n\n    &__tr:hover {\n        height: 50px;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        padding: 8px 32px;\n        background: #fffcf2;\n        // cursor: pointer;\n    }\n\n    &__td {\n        border-bottom: 1px solid #e9e9e9;\n        border-top: 1px solid #868686;\n\n        &__table-name {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            color: #505054;\n            border-top: 1px solid #E9E9E9;\n            border-bottom: 1px solid #E9E9E9;\n        } \n\n        &__table-content {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            color: #505054;\n            border-top: 1px solid #E9E9E9;\n            border-bottom: 1px solid #E9E9E9;\n        }   \n    }\n\n    &__td-center {\n        text-align: center;\n        border-bottom: 1px solid #e9e9e9;\n        border-top: 1px solid #868686;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n        // cursor: pointer;\n        padding-left: 10px;\n    }\n\n    // &__td-content {\n    //     border-bottom: 1px solid #e9e9e9;\n    //     border-top: 1px solid #868686;\n\n    //     font-family: 'Spoqa Han Sans Neo';\n    //     font-style: normal;\n    //     font-weight: 400;\n    //     font-size: 14px;\n    //     line-height: 20px;\n    //     color: #505054;\n    //     padding-left: 10px;\n    // }\n\n    &__th {\n        background: #fafafa;\n    }\n\n    &__buttons {\n        padding: 20px;\n        display: flex;\n\n        &__cancel {\n            padding-right: 10px;\n        }\n    }\n}\n\n.table-height {\n    height: 50vh;\n    padding: 10px;\n}\n\n.no-data {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #c1c1c1;\n\n    height: 50vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.employee-registration-popup {\n    margin: auto;\n    // width: 138px;\n    // height: 84px;\n    padding: 12px;\n    background-color: #ffffff !important;\n    border: 1px solid #e9e9e9;\n    border-radius: 8px;\n    // box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n\n    &__icon {\n        cursor: pointer;\n    }\n\n    &__resend-invite {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        color: #333333;\n        cursor: pointer;\n        padding-top: 4px;\n    }\n\n    &__delete-invite {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        color: #333333;\n        cursor: pointer;\n        padding-top: 12px;\n    }\n\n    &__pop:hover {\n        background-color: rebeccapurple;\n        color: white;\n    }\n}\n\n.popup-content {\n    border: none;\n    background: none;\n}\n\n[role='tooltip'].popup-content {\n    box-shadow: none;\n    border-radius: 5px;\n}\n\n.error {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    color: #bbbbbb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
